import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './app.layout';
import { Permission } from './library/config/auth/permissions/permission';
import { AuthGuard } from './library/guards/auth.guard';

const routes: Routes = [
    { path: '', redirectTo: 'app', pathMatch: 'full' },

    {
        path: 'auth',
        loadChildren: () =>
            import('./modules/auth/auth.module').then(m => m.AuthModule)
    },

    {
        path: 'maintenance',
        loadChildren: () =>
            import('./modules/maintenance/maintenance.module').then(
                m => m.MaintenanceModule
            )
    },

    //authed section of app
    {
        path: '',
        canActivate: [AuthGuard],
        children: [
            {
                path: 'user',
                data: { permissions: [Permission.User.read] },
                loadChildren: () =>
                    import('./pages/user/user.module').then(m => m.UserModule)
            },
            {
                path: 'admin',
                data: { permissions: [Permission.AdminSettings.view] },
                loadChildren: () =>
                    import('./pages/admin-settings/admin-settings.module').then(
                        m => m.AdminSettingsModule
                    )
            },
            {
                path: 'app',
                component: AppLayoutComponent,
                children: [
                    {
                        path: '',
                        redirectTo: 'home',
                        pathMatch: 'full'
                    },
                    {
                        path: 'dashboards',
                        data: { permissions: [Permission.Dashboard.view] },
                        loadChildren: () =>
                            import(
                                './modules/dashboards/dashboards.module'
                            ).then(m => m.DashboardsModule)
                    },
                    {
                        path: 'cases',
                        data: { permissions: [Permission.Cases.read] },
                        loadChildren: () =>
                            import('./pages/case/case.module').then(
                                m => m.CaseModule
                            )
                    },
                    {
                        path: 'claims',
                        data: { permissions: [Permission.Claim.read] },
                        loadChildren: () =>
                            import('./pages/claim/claim.module').then(
                                m => m.ClaimModule
                            )
                    },
                    {
                        path: 'client',
                        data: { permissions: [Permission.Client.read] },
                        loadChildren: () =>
                            import('./pages/client/client.module').then(
                                m => m.ClientModule
                            )
                    },
                    {
                        path: 'diary',
                        data: { permissions: [Permission.Diary.read] },
                        loadChildren: () =>
                            import('./pages/diary/diary.module').then(
                                m => m.DiaryModule
                            )
                    },
                    {
                        path: 'serviceproviders',
                        data: {
                            permissions: [Permission.ServiceProvider.read]
                        },
                        loadChildren: () =>
                            import(
                                './pages/service-provider/service-provider.module'
                            ).then(m => m.ServiceProviderModule)
                    },
                    {
                        path: 'usermanagement',
                        data: { permissions: [Permission.User.read] },
                        loadChildren: () =>
                            import(
                                './pages/user-management/user-management.module'
                            ).then(m => m.UserManagementModule)
                    },
                    {
                        data: { permissions: [Permission.Payments.read] },
                        path: 'payments',
                        loadChildren: () =>
                            import('./modules/payments/payments.module').then(
                                m => m.PaymentsModule
                            )
                    },
                    {
                        path: 'home',
                        loadChildren: () =>
                            import('./modules/home/home.module').then(
                                m => m.HomeModule
                            )
                    },
                    {
                        path: 'calls',
                        data: { permissions: [Permission.Call.read] },
                        loadChildren: () =>
                            import('./pages/calls/calls.module').then(
                                m => m.CallsModule
                            )
                    },

                    { path: '**', redirectTo: 'home' }
                ]
            }
        ]
    },
    { path: '**', redirectTo: '/app' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'top',
            relativeLinkResolution: 'legacy'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
